import { QueryClient } from '@tanstack/react-query';
import { ApiError } from './api';

/**
 * Shared TanStack Query client.
 *
 * Defaults tuned for a CRM:
 *  - staleTime 30s: a kanban or list refreshed in the last 30s is fresh
 *    (avoids refetch storms when user navigates inquiry ↔ client ↔ back).
 *  - retry: don't retry 4xx (auth/permission/validation — retrying won't help).
 *  - refetchOnWindowFocus enabled — important for shared workspace where
 *    another user may have advanced an inquiry status.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      retry: (failureCount, error) => {
        if (error instanceof ApiError && error.status >= 400 && error.status < 500) {
          return false;
        }
        return failureCount < 2;
      },
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
    },
    mutations: {
      retry: false,
    },
  },
});
